export class OFormValue {
  value: any;
  constructor(value ?: any) {
    this.value = value;
  }
}
